import { createSlice } from "@reduxjs/toolkit";

import type { PayloadAction } from "@reduxjs/toolkit";

export interface TelegramState {
  initData: string | null;
  isInitDataObtained: boolean;
  isNewUser: boolean;
}

const initialState: TelegramState = {
  initData: null,
  isInitDataObtained: false,
  isNewUser: false,
};

const telegramSlice = createSlice({
  name: "telegram",
  initialState,
  reducers: {
    setInitData: (state, action: PayloadAction<string>) => {
      state.initData = action.payload;
    },
    setIsInitDataObtained: (state, action: PayloadAction<boolean>) => {
      state.isInitDataObtained = action.payload;
    },
    setIsNewUser: (state, action: PayloadAction<boolean>) => {
      state.isNewUser = action.payload;
    },
  },
});

export const { setInitData, setIsNewUser, setIsInitDataObtained } =
  telegramSlice.actions;
export default telegramSlice.reducer;
